module.exports = __webpack_public_path__ + "static/img/normal-scan-right.b3fb9151.jpg";